<template>
  <li v-if="onlyItemsPage && requireCustomers && customers.length > 0">
    <label class="customers-dropdown-label">
      客戶選擇:
      <!-- 以 vue-select 提供搜尋，行為對齊原本 native select -->
      <v-select
        ref="customerSelect"
        v-model="currentCustomerId"
        class="customers-v-select"
        :options="customers"
        :reduce="customer => customer.key"
        label="value"
        :clearable="false"
        :searchable="true"
        :disabled="itemLoading"
        placeholder=""
        @input="changeCustomer"
      >
        <template #no-options>找不到符合資料</template>
      </v-select>
    </label>
  </li>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";
import vSelect from "vue-select";

export default {
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      currentCustomerId: null,
      tempCustomerId: null,
      customers: [],
      requireCustomers: true,
    };
  },
  computed: {
    getCustomers() {
      return this.$store.state.customers;
    },
    getCurrentCustomer() {
      return this.$store.state.currentCustomer;
    },
    onlyItemsPage: function () {
      // 允許出現的網址
      const allowedUrls = ["/items"];
      if (allowedUrls.includes(window.location.pathname)) {
        return true;
      } else {
        return false;
      }
    },
    couponType() {
      return this.$store.state.couponType;
    },
    couponTypes() {
      return this.$store.state.couponTypes;
    },
    itemLoading() {
      return this.$store.state.itemsLoading;
    },
  },
  watch: {
    getCustomers: function () {
      this.customers = this.getCustomers;
    },
    getCurrentCustomer: function () {
      // 先寫 temp，避免 v-select @input 誤觸發變更流程
      this.tempCustomerId = this.getCurrentCustomer ? this.getCurrentCustomer.id : null;
      this.currentCustomerId = this.tempCustomerId;
      if (this.currentCustomerId) {
        // console.log("currentCouponType", this.couponTypes.find(type => this.couponType === type.key))
        this.requireCustomers = true;
      } else {
        this.requireCustomers = false;
      }
    },
    couponType: function () {
      const currentCouponType = this.couponTypes.find((type) => this.couponType === type.key);
      this.requireCustomers = currentCouponType ? currentCouponType.require_customers : false;
    },
  },
  methods: {
    // 關閉 vue-select 下拉（SweetAlert 出現時否則會一直開著）
    closeCustomerSelect() {
      const select = this.$refs.customerSelect;
      if (!select) {
        return;
      }
      select.open = false;
      select.search = "";
      if (select.searchEl && typeof select.searchEl.blur === "function") {
        select.searchEl.blur();
      }
    },
    changeCustomer: function (selectedId) {
      // 程式更新 v-model 或選回同一客戶時不重複詢問
      if (selectedId === this.tempCustomerId) {
        return;
      }
      // 先收合下拉，再跳出確認（否則與 Swal 同時顯示會卡在開啟狀態）
      this.closeCustomerSelect();
      this.$nextTick(() => {
        this.closeCustomerSelect();
      });
      Swal.fire({
        title: "確定要更改客戶嗎?",
        text: "更改後將清除購物車內容!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消",
      }).then((result) => {
        if (result.isConfirmed) {
          // 設定items為空值
          this.$store.commit('set_items', []);
          this.$store.dispatch("setCurrentCustomer", selectedId);
          // 清除購物車
          // 直接call api一次，再dispatch一次，避免session[:cart]一直無法清除的問題
          axios.delete("/api/clear_cart").then(({ data }) => {
            if (data.success) {
              this.$store.dispatch("clearCurrentCart");
              // setTimeout(() => {
              //   this.$store.dispatch("clearCurrentCart");
              // }, 500);
              // setTimeout(() => {
              //   this.$store.dispatch("clearCurrentCart");
              // }, 1000);
            }
          });
        } else {
          // this.$store.dispatch('setCurrentCustomer', this.tempCustomerId);
          const prevId = this.tempCustomerId;
          this.currentCustomerId = null;
          this.$nextTick(() => {
            this.currentCustomerId = prevId;
            this.closeCustomerSelect();
          });
        }
      });
    },
  },
};
</script>

<style scoped>
/* 盡量贴近原本 inline select（寬度 150px） */
.customers-dropdown-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  position: relative;
}

.customers-v-select {
  width: 150px;
  display: inline-block;
  vertical-align: middle;
  font-size: inherit;
  position: relative;
}

/* 使用 ::v-deep 確保穿透 scoped，正確覆寫 vue-select 內部樣式 */
.customers-v-select ::v-deep .vs__dropdown-toggle {
  padding: 0 0 0 4px;
  border: 1px solid #767676;
  border-radius: 0;
  background: #fff;
  min-height: 24px;
  height: auto;
  cursor: pointer !important;
}

.customers-v-select ::v-deep .vs__selected {
  margin: 0 2px 0 0;
  padding: 0;
  border: none;
  line-height: 22px;
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  cursor: pointer !important;
}

.customers-v-select ::v-deep .vs__search,
.customers-v-select ::v-deep .vs__search:focus {
  margin: 0;
  padding: 1px 0;
  line-height: 22px;
  border: none;
  box-shadow: none;
  font-size: inherit;
  background: transparent;
  cursor: pointer !important;
}

/* searchable 模式預設 cursor:text，強制改為 pointer */
.customers-v-select.vs--searchable ::v-deep .vs__dropdown-toggle,
.customers-v-select ::v-deep .vs__selected-options {
  cursor: pointer !important;
}

.customers-v-select ::v-deep .vs__actions {
  padding: 0 4px 0 0;
  cursor: pointer !important;
}

.customers-v-select ::v-deep .vs__clear {
  display: none;
}

.customers-v-select ::v-deep .vs__open-indicator {
  transform: scale(0.7);
  fill: #333;
}

/*
  header .header-right li { display: inline-block } 會讓選項橫排擠在一起；
  下拉區塊加寬 80%：150px → 270px，每個選項各占一列，並關掉 overflow-x
*/
.customers-v-select ::v-deep .vs__dropdown-menu {
  width: 270px !important;
  min-width: 270px !important;
  max-width: 270px !important;
  left: 0;
  right: auto;
  display: block !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  white-space: normal;
  border-radius: 0;
  font-size: inherit;
  z-index: 2000;
  box-sizing: border-box;
  cursor: pointer;
}

.customers-v-select ::v-deep .vs__dropdown-menu > li,
.customers-v-select ::v-deep .vs__dropdown-option {
  display: block !important;
  float: none !important;
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 4px 8px;
  box-sizing: border-box;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  text-align: left;
  cursor: pointer;
}
</style>
